import { useSearchParams } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { Card, Collapse, Grid, MenuItem, TextField } from "@mui/material";
import DateRangePicker from "../../../common/DateRangePicker";
import dayjs from "dayjs";
import {TableFilterButtons} from "../../../common/TableFilterButtons";

export function ChangelogsTableFilter({ isOpenFilters, isLoadingList }) {
    const [searchParams, setSearchParams] = useSearchParams();

    const nome = searchParams.get("nome");
    const tipo = searchParams.get("tipo");
    const data_inicio = searchParams.get("data_inicio");
    const data_fim = searchParams.get("data_fim");
    const perPage = searchParams.get("perPage");

    const { handleSubmit, control, setValue, watch, reset } = useForm({
        defaultValues: {
            nome: nome ?? "",
            tipo: tipo ?? "",
            data_inicio: data_inicio ?? "",
            data_fim: data_fim ?? "",
        },
    });

    const dateInicio = watch("data_inicio");
    const dateFim = watch("data_fim");

    function handleSubmitFilter(data) {
        for (const key in data) {
            if (data[key] === "") {
                delete data[key];
            }
        }

        const queryFilters = {
            ...data,
            page: "1",
            perPage: perPage ?? "10",
        };

        setSearchParams(queryFilters);
    }

    return (
        <Grid item xs={12} component="form" onSubmit={handleSubmit(handleSubmitFilter)}>
            <Collapse in={isOpenFilters}>
                <Card variant="outlined" sx={{ padding: 2 }}>
                    <Grid container spacing={2}>
                        {/* Nome */}
                        <Grid item xs={12} md={4}>
                            <Controller
                                name="nome"
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        label="Nome da Alteração"
                                        fullWidth
                                        size="small"
                                        {...field}
                                    />
                                )}
                            />
                        </Grid>

                        {/* Tipo */}
                        <Grid item xs={12} md={4}>
                            <Controller
                                name="tipo"
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        select
                                        label="Tipo"
                                        fullWidth
                                        size="small"
                                        {...field}
                                    >
                                        <MenuItem value="">Todos</MenuItem>
                                        <MenuItem value="funcionalidade">Funcionalidade</MenuItem>
                                        <MenuItem value="alteracao">Alteração</MenuItem>
                                        <MenuItem value="alerta">Alerta</MenuItem>
                                    </TextField>
                                )}
                            />
                        </Grid>

                        {/* Data */}
                        <Grid item xs={12} md={4}>
                            <DateRangePicker
                                value={[
                                    dateInicio ? dayjs(dateInicio).toDate() : null,
                                    dateFim ? dayjs(dateFim).toDate() : null,
                                ]}
                                bgColor="#fff"
                                onChange={(value) => {
                                    const [start, end] = value;
                                    setValue("data_inicio", start ? dayjs(start).format("YYYY-MM-DD") : "");
                                    setValue("data_fim", end ? dayjs(end).format("YYYY-MM-DD") : "");
                                }}
                                onReset={() => {
                                    setValue("data_inicio", "");
                                    setValue("data_fim", "");
                                }}
                            />
                        </Grid>

                        <TableFilterButtons
                            isLoading={isLoadingList}
                            handleClearFilters={() => {
                                setSearchParams((state) => {
                                    state.delete('nome')
                                    state.delete('tipo')
                                    state.delete('data_inicio')
                                    state.delete('data_fim')
                                    state.set('page', '1')

                                    return state
                                })

                                reset({
                                    nome: '',
                                    tipo: '',
                                    data_inicio: '',
                                    data_fim: '',
                                });
                            }}
                        />
                    </Grid>
                </Card>
            </Collapse>
        </Grid>
    );
}
